export default __webpack_public_path__ + "static/media/Naureen Saleem.5bf2975c.jpeg";